import { useTranslation } from 'react-i18next';

import { Button } from 'components/Button';

import * as S from './StepOne.styles';

type StepOneProps = {
  onClose: () => void;
  isStepTwoSet: (arg: boolean) => void;
};

export function StepOne(props: StepOneProps): React.ReactElement {
  const { onClose, isStepTwoSet } = props;
  const { t } = useTranslation();

  return (
    <>
      <S.Title scale="xl3">{t('order.noSelected')}</S.Title>

      <S.Info fontFamily="LFT Zeno" fontWeight="extraLight" scale="s">
        {t('order.noSelectedCreate')}
      </S.Info>

      <S.Actions>
        <Button
          textTransform="isFirstLetterUppercase"
          fontFamily="LFT Zeno"
          fontWeight="light"
          motive="cancelTertiary"
          scale="s"
          onClick={onClose}
        >
          {t('common.cancel')}
        </Button>

        <Button
          textTransform="isFirstLetterUppercase"
          fontFamily="LFT Zeno"
          motive="actionPrimary"
          onClick={() => {
            isStepTwoSet(true);
          }}
        >
          {t('order.createNewOrder')}
        </Button>
      </S.Actions>
    </>
  );
}
